export default {
    de: {
        close: "Schließen",
        downloadOptions: "Download-Optionen",
        iiifManifest: "IIIF-Manifest",
        image: "Scan",
        otherDownloadOptions: "Weitere Links",
        pixels: "Pixel",
        showDownloadOptions: "Download-Optionen anzeigen",
        pdfTitleLabel: "Gesamtes Objekt",
        pdfDescriptionLabel: "PDF erstellen",
        ocrFile: "Volltext (OCR)"
    },
    en: {
        close: "Close",
        downloadOptions: "Download options",
        iiifManifest: "IIIF manifest",
        image: "Scan",
        otherDownloadOptions: "Other links",
        pixels: "pixels",
        showDownloadOptions: "Show download options",
        pdfTitleLabel: "Full Digitization",
        pdfDescriptionLabel: "Generate PDF",
        ocrFile: "Full text (OCR)"
    },
    /*
    fr: {
        close: "Fermer",
        downloadOptions: "Options de téléchargement",
        iiifManifest: "Manifeste IIIF",
        image: "Image",
        otherDownloadOptions: "Autres liens de téléchargement",
        pixels: "pixels",
        showDownloadOptions: "Afficher les options de téléchargement",
    },

     */
};
